/**
 * Created by yangzhao on 18/9/20.
 */
exports.install = function (Vue, options) {
  Vue.prototype.isString = function (obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
  };
  Vue.prototype.respDataHandle = function (data, callBack, errorHandle) {
    var jsonObj;
    if (this.isString(data)) {
      jsonObj = JSON.parse(data)
    } else {
      jsonObj = data
    }
    var errorCode = jsonObj.errorCode
    var errorMessage = jsonObj.errorMessage
    if (errorCode == 8 || errorCode == 1) {
      this.$router.push("/login")
      return
    }
    if (errorCode != 0) {
      this.errToastr(errorMessage)
      errorHandle(errorCode, errorMessage)
      return
    }


    callBack(jsonObj.data)
  };
  Vue.prototype.formatDateTime = function (inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  };
  Vue.prototype.vueFormatDateTime = function (row, column, cellValue) {
    var date = new Date(cellValue);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  };
  Vue.prototype.setToken = function (token) {
    localStorage.setItem("token", token)
  };
  Vue.prototype.getToken = function () {
    return localStorage.getItem("token")
  };
  Vue.prototype.removeToken = function () {
    return localStorage.clear("token")
  };
  Vue.prototype.isPhoneNum = function (phone) {
    var pattern = /^1[3456789]\d{9}$/;
    return pattern.test(phone);
  };
  Vue.prototype.errToastr = function (errorMessage) {
    this.$message.error(errorMessage);
  };
  Vue.prototype.successToastr = function (message) {
    this.$message({
      message: message,
      type: 'success'
    });
  };
  Vue.prototype.getAccount = function (callBack) {
    var self = this
    var token = this.getToken()
    this.$http.post(this._Global.HTTP_SERVER + "/auth/token", {
      "authToken": token
    }).then(response => {
      self.respDataHandle(response.body, function (respData) {
        if (respData != null && respData != undefined) {
          callBack(respData)
        }

      })
    })
  };
  Vue.prototype.delete_app = function (link, callBack) {
    if (confirm("删除后不可恢复，请谨慎操作")) {
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/delete", {
          shortLink: link,
          authToken: this.getToken()
        })
        .then(response => {
          this.respDataHandle(response.body, function () {
            callBack()
          });
        });
    }
  };
  Vue.prototype.readPlist = function (file, callBack) {
    file.async("string").then(function (content) {
      var pi = plist.parse(content)
      var packageInfo = {}
      //应用包名
      packageInfo.bundleId = pi.CFBundleIdentifier
      //应用名称
      packageInfo.appName = pi.CFBundleName
      //应用版本
      packageInfo.appVersion = pi.CFBundleShortVersionString
      //应用展示的名称
      packageInfo.appShowName = pi.CFBundleDisplayName
      //应用所需IOS最低版本
      packageInfo.minimumOSVersion = pi.MinimumOSVersion
      var iconFiles = pi.CFBundleIcons.CFBundlePrimaryIcon.CFBundleIconFiles
      //icon 名称
      packageInfo.iconName = iconFiles[iconFiles.length - 1]
      callBack(packageInfo)
    })
  };
  Vue.prototype.remoteReadPlist = function (file, callBack) {
    var self = this
    file.async("blob").then(function (blob) {
      self.fileUpload(self._Global.HTTP_SERVER + "/plist/parse", blob, function (respData) {
        self.respDataHandle(respData, function (respData) {
          var packageInfo = {}
          //应用包名
          packageInfo.bundleId = respData.identifier
          //应用名称
          packageInfo.appName = respData.appName
          //应用版本
          packageInfo.appVersion = respData.bundleShortVersion
          //应用展示的名称
          packageInfo.appShowName = respData.appName
          //应用所需IOS最低版本
          packageInfo.minimumOSVersion = respData.minOSVersion
          packageInfo.iconName = respData.bundleIconName
          callBack(packageInfo)
        })
      })
    })
  };
  //读取安装包信息
  Vue.prototype.readPkgInfo = function (f, callBack) {
    var self = this
    var fileSuffixName = f.name.substr(f.name.length - 4, f.name.length)
    if (fileSuffixName != ".ipa" && fileSuffixName != ".apk") {
      this.errToastr("请上传 ipa | apk安装包")
      return
    }
    var packageInfo = {}
    packageInfo.bigFile = false
    packageInfo.iConId = 0
    if (fileSuffixName == ".apk") {
      packageInfo.osName = "Android"
      callBack(packageInfo)
      return
    }
    if(f.size>(2*1024*1024*1024)){
      packageInfo.osName = "iOS"
      packageInfo.bigFile = true
      callBack(packageInfo)
      return
    }
    var zipJs = new JSZip()
    zipJs.loadAsync(f).then(function (zip) {
      var exec = 0;
      var relativePaths = []
      let plistFile=null
      zip.forEach(function (relativePath, file) {
        var paths=relativePath.split("/")
        if (paths[0] == "Payload" && paths[2] == "Info.plist") {
          plistFile=file
          return false
        }
      })
      self.remoteReadPlist(plistFile, function (pkgInfo) {
        packageInfo = pkgInfo
        console.log(packageInfo)
        var iconName = packageInfo.iconName
        zip.forEach((relativePath, file) =>{
          var paths = relativePath.split("/")
          const result = paths.slice(2).join('/');
          if (result==iconName+".png") {
            console.log("iconPath ==> " + relativePath)
            exec = 1;
            file.async("blob").then(function (blob) {
              self.fileUpload(self._Global.HTTP_SERVER + "/auth/app/iOS/icon/parse?authToken=" + self.getToken(), blob, function (data) {
                self.respDataHandle(data, function (respData) {
                  packageInfo.iConData = respData.iData
                  packageInfo.iConUrl = respData.iconUrl
                  packageInfo.iConId = respData.id
                  packageInfo.osName = "iOS"
                  console.log(packageInfo)
                  callBack(packageInfo)
                })
              })
            })
            return false
          }
          // var iconName = "AppIcon"
          if (relativePath.indexOf("AppIcon") >= 0) {
            relativePaths.push(relativePath)
          }
        })
        if (exec == 0) {
          var path = relativePaths[relativePaths.length - 1]
          zip.forEach((relativePath, file) =>{
            if (relativePath.indexOf(path) >= 0 && exec == 0) {
              exec = 1
              file.async("blob").then(function (blob) {
                self.fileUpload(self._Global.HTTP_SERVER + "/auth/app/iOS/icon/parse?authToken=" + self.getToken(), blob, function (data) {
                  self.respDataHandle(data, function (respData) {
                    packageInfo.iConData = respData.iData
                    packageInfo.iConUrl = respData.iconUrl
                    packageInfo.iConId = respData.id
                    packageInfo.osName = "iOS"
                    console.log(packageInfo)
                    callBack(packageInfo)
                  })
                })
              })
            }
          })
        }
      })
    })
  };
  Vue.prototype.fileUpload = function (url, blob, callBack) {
    var oReq = new XMLHttpRequest();
    oReq.open("POST", url, true);
    oReq.onload = function (oEvent) {
      var jsonString = oReq.response;
      callBack(jsonString)

    };
    oReq.send(blob);
  };
  Vue.prototype.sleep = function (delay) {
    var start = (new Date()).getTime();
    while ((new Date()).getTime() - start < delay) {
      continue;
    }
  };
  Vue.prototype.cacheSet = function (k, v) {
    localStorage.setItem(k, v)
  };
  Vue.prototype.cacheGet = function (k) {
    return localStorage.getItem(k)
  };
  Vue.prototype.cacheRemove = function (k) {
    localStorage.clear(k)
  };
  Vue.prototype.getScreenWidth = function () {
    return $(document).width()
  };
  Vue.prototype.getScreenHeight = function () {
    return $(document).height()
  };
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js